module.exports = __webpack_public_path__ + "static/media/salary-work-time.e5d6ce2c.jpg";